module.exports = __webpack_public_path__ + "static/media/image-7.f7ff677f.jpg";